export const MenuRoutes = [
    {
        title:'Home',
        path:'/'
    }, {
        title:'Sands RWA Market(ERC1155)',
        path:'/collectionsv2'
    }, 
    {
        title:'Ecosystem',
        path:'/ecosystem',
        elements:[ 
            {title:'Rock RWA Market(ERC721)',path:'https://rock.rwahubs.com/#/collectionsv2', outLink:true}, 
            {title:'More...',path:'/comming'} 
        ]
    }, 
    {
        title:'Studio',
        path:'/studio',
        elements:[ 
            {title:'My Team wallets',path:'/mywhitelistspagev2'},
            {title:'Create Collection',path:'/createcolletionv2'},
            {title:'Create NFT',path:'/createnftv2'}, 
        ]
    }, 
    {
        title:'About Us',
        path:'https://www.rwahubs.com'
    }
]

 